import gql from 'graphql-tag';
import apolloClient from '../apollo';

/**
 * State
 */
const getDefaultState = () => {
  return {
    ordersExportBuildState: null,
  };
};

const state = getDefaultState();

/**
 * Actions
 */
const actions = {
  /**
   * Reset state in module
   * @param commit
   */
  reset({ commit }) {
    commit('SET_DEFAULT_STATE');
  },

  /**
   * Queue orders export
   * @param {*} param0
   * @param {*} payload
   */
  async ordersExport({ commit, dispatch }, { userId, pagination, sorting, filters }) {
    console.log('ordersExport()', userId, pagination, sorting, filters);
    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation ordersExport(
            $userId: ID!
            $pagination: PaginationInput!
            $sorting: SortingInput!
            $filters: OrderFilterInput!
          ) {
            ordersExport(
              userId: $userId
              pagination: $pagination
              sorting: $sorting
              filters: $filters
            )
          }
        `,
        variables: {
          userId,
          pagination,
          sorting,
          filters,
        },
      });

      commit('SET_ORDERS_EXPORT_BUILD_STATE', response.data.ordersExport);

      dispatch('message', {
        message: 'Export gestartet!',
        type: 'success',
        lifetime: 2,
      });

      return response.data.ordersExport;
    } catch (err) {
      dispatch('message', {
        message: 'Fehler beim Starten des Exports!',
        type: 'danger',
        lifetime: 1,
      });
      throw new Error(err);
    }
  },
};

/**
 * Mutations
 */
const mutations = {
  SET_DEFAULT_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_ORDERS_EXPORT_BUILD_STATE: (state, buildState) => {
    state.ordersExportBuildState = buildState;
  },
};

/**
 * Getters
 */
const getters = {
  getOrdersExportBuildState: (state) => state.ordersExportBuildState,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
